import React from "react";
import moment from "moment";
import { Table, TableCell, TableRow } from "~/table";
import { GetTrainingReportQuery } from "./getTrainingReport.hotchoc.generated";
import { CertificateActions } from "./CertificateActions";

type TrainingRecord =
  GetTrainingReportQuery["training"]["report"]["records"][number];

type TrainingReportResultsProps = {
  records: TrainingRecord[];
  loading: boolean;
};

const formatHours = (duration: string): string => {
  const parts = duration.split(":");
  const days = parseInt(parts[0], 10);
  const hours = days * 24 + parseInt(parts[1], 10);
  const minutes = parts[2];
  return `${hours}:${minutes}`;
};

export const TrainingReportResults: React.FC<TrainingReportResultsProps> = ({
  records,
  loading,
}) => {
  if (records.length === 0) {
    if (loading) return null;
    return <p>No results found.</p>;
  }

  return (
    <Table columnWidths="1fr 1fr 1fr 1fr 120px" columnCount={5}>
      <TableRow header>
        <TableCell text="Employee" />
        <TableCell text="Training Date" />
        <TableCell text="Training Type" />
        <TableCell text="Hours" />
        <TableCell text="Upload" />
      </TableRow>
      {records.map((record, idx) => (
        <TableRow key={idx}>
          <TableCell
            text={`${record.employee.firstName} ${record.employee.lastName}`}
          />
          <TableCell
            text={moment(record.trainingDate, "YYYY-MM-DD").format(
              "MM/DD/YYYY"
            )}
          />
          <TableCell text={record.trainingType} />
          <TableCell text={formatHours(record.trainingHours)} />
          <CertificateActions
            certificateImageId={record.certificateImageId}
            employeeName={`${record.employee.lastName}-${record.employee.firstName}`}
            trainingDate={record.trainingDate}
          />
        </TableRow>
      ))}
    </Table>
  );
};
